<template>
  <div class="container">
    <div class="text-end p-3">
      <c-primary-button to="/admin/tipos-de-documentos/crear">
        Crear tipo de documento
      </c-primary-button>
    </div>
    <c-card title="Tipos de documentos">
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Tipo</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="document in documentTypes" :key="document.id">
            <td>{{ document.name }}</td>
            <td class="text-nowrap">
              <router-link
                class="btn btn-secondary btn-sm ms-2 d-inline-block"
                :to="`/admin/tipos-de-documentos/${document.id}/editar`"
                title="Editar"
                ><i class="fa-solid fa-pen"></i
              ></router-link>
              <a
                class="btn btn-secondary btn-sm ms-2 d-inline-block"
                href="javascript:void(0)"
                @click="deleteDocumentType(document.id)"
                title="Eliminar"
                ><i class="fa-solid fa-trash-can"></i
              ></a>
            </td>
          </tr>
        </tbody>
      </table>
    </c-card>
  </div>
</template>
<script>
import CCard from "@/components/CCard.vue";
import CPrimaryButton from "@/components/CPrimaryButton.vue";
import { all, remove } from "@/services/document_types";
import { showNotification } from "@/services/notification";

export default {
  components: {
    CCard,
    CPrimaryButton,
  },
  data() {
    return {
      documentTypes: [],
    };
  },
  mounted() {
    this.getDocumentTypes();
  },
  methods: {
    getDocumentTypes() {
      all().then((response) => {
        this.documentTypes = response.data;
      });
    },
    deleteDocumentType(id) {
      const removeRecord = confirm("¿Estás seguro de eliminar el registro?");
      if (!removeRecord) {
        return;
      }
      remove(id).then(() => {
        showNotification(204, "success", "El registro fue eliminado.");
        this.getDocumentTypes();
      });
    },
  },
};
</script>
